export const CUSTOMER_TAG_INFO = "CUSTOMER_TAG_INFO";
export const CUSTOMER_TAG_INFO_SUCCESS = "CUSTOMER_TAG_INFO_SUCCESS";
export const CUSTOMER_TAG_INFO_FAIL = "CUSTOMER_TAG_INFO_FAIL";
